import { FiMenu } from '@react-icons/all-files/fi/FiMenu';
import { GrFormClose } from '@react-icons/all-files/gr/GrFormClose';
import React, { Fragment, useState } from 'react';

import { tw } from '../../utils/tailwind';
import { Box, Flex, Stack } from '../Core';

interface IBurgerMenuProps {
  currentPath: string;
  // display: string | undefined | (string | null)[] | { [key: string]: string };
  languageSelector?: JSX.Element;
  menuItems: (JSX.Element | undefined)[];
  footerElements?: (JSX.Element | undefined)[];
  siteUrl: string | undefined;
}
const BurgerMenu: FCWithClassName<IBurgerMenuProps> = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const burgerMenuItems = props.menuItems.map((menuItem) => {
    if (!menuItem) return undefined;
    return React.cloneElement(menuItem, { menuType: 'burger' });
  });
  return (
    <Fragment>
      {isOpen ? (
        <GrFormClose
          className="fixed top-0 z-20 w-8 h-8 mt-4 mr-6"
          onClick={() => setIsOpen(!isOpen)}
        />
      ) : (
        <FiMenu
          className={tw('block w-10 h-10 xl:hidden', props.className)}
          onClick={() => setIsOpen(!isOpen)}
        />
      )}
      <Box
        className={`top-0 right-0 fixed w-screen h-full pl-6 bg-white ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        } ease-in-out duration-300`}
      >
        <Box className="py-4 ">{props.languageSelector}</Box>
        <Flex
          direction="column"
          justify="space-between"
          className="min-h-[85vh] select-none px-4"
        >
          <Box>
            <Stack className="space-y-8">{burgerMenuItems}</Stack>
          </Box>
          <Flex justify="flex-start" align="center">
            <Stack isInline className="space-x-4">
              {props.footerElements}
            </Stack>
          </Flex>
        </Flex>
      </Box>
    </Fragment>
  );
};

export default BurgerMenu;
